import { action, observable } from 'mobx';
import { get } from '../../utils/request';

export interface DriverProps {
    uid: string;
    first_name: string;
    last_name: string;
    email: string;
}

class Driver {
    @observable isLoading = false;
    @observable drivers: DriverProps[] = [];

    @action getDrivers(params = {}) {
        this.isLoading = true;
        get('/drivers/', params)
            .then(response => {
                this.drivers = response.data.results || response.data;
            })
            .catch(err => console.log(err))
            .finally(() => (this.isLoading = false));
    }
}

export const DriverAdminStore = new Driver();
